import React from "react";
import Stack from "../Stack";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import { capitalizeWords } from "../../utils/tools";

interface CustomLabeledProps {
  children: React.ReactNode;
  name: string;
}

const StyledDiv = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  "& > span": {
    fontWeight: "bold",
    color: "#2B3674",
  },
  "& > p": {
    fontWeight: "bold",
    color: "#2B3674",
  },
  "& > a > span": {
    fontWeight: "bold",
    color: "#2B3674",
  },
});

const CustomLabeled: React.FC<CustomLabeledProps> = ({ name, children }) => {
  return (
    <Stack direction="row" justifyContent="flex-start" spacing={2}>
      <Typography variant="body2">{capitalizeWords(name)} :</Typography>
      <StyledDiv>{children}</StyledDiv>
    </Stack>
  );
};

export default CustomLabeled;
